import {onPatch, types} from "mobx-state-tree";

export const InteractionsStore = types
    .model('InteractionsStore', {
        highlightedProgramItem: types.optional(types.string, ''),
        tooltipIndex: types.optional(types.integer, -1),
        clientWidth: types.integer,
        clientHeight: types.integer,
        cardFlipWidth: types.map(types.number),
        cardFlipHeight: types.map(types.number),
    })
    .actions(self => ({
        setHighlightedProgramItem(id) {
            self.highlightedProgramItem = id;
        },
        setTooltipIndex(idx) {
            self.tooltipIndex = idx;
        },
        setCardFlipSize(index, width, height) {
            // console.log(`setCardFlipSize ${index} : ${width}, ${height}`);
            self.cardFlipWidth[index] = width;
            self.cardFlipHeight[index] = height;
        },
        setClientSize(width, height) {
            self.clientWidth = width;
            self.clientHeight = height;
        }
    })).views(self => ({
        get mobileMode() {
            return self.clientWidth <= 768;
            // return self.clientHeight / self.clientWidth > 1.2;
        },
        getCardFlipWidth(index) {
            return self.cardFlipWidth[index] || 800;
        },
        getCardFlipHeight(index) {
            return self.cardFlipHeight[index] || 520;
        },
    }));
export const interactionsStore = InteractionsStore.create({
    clientWidth: document.documentElement.clientWidth,
    clientHeight: document.documentElement.clientHeight
});



